import React, { useState } from 'react'
import { TextField, Toolbar, Typography, Button, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { isRoleCheckList } from 'app/utils/appHelpers';
import AddIcon from '@mui/icons-material/Add';
import AddUpdateAgendaTemplateDialog from '../../Dialog/AddUpdateAgendaTemplateDialog';

function AgendaTemplateDataTableToolbar({ pageTitle, data2, setData, afterUpdateFunc, addAfterTable, type, setHighlightQuery }) {    const { authUser } = useSelector(state => state.auth);

    const [searchText, setSearchText] = useState("");
    const [addDialogStatus, setAddDialogStatus] = useState(false);

    const handleSearch = (event) => {
        const searchValue = event.target.value;
        setSearchText(searchValue);
        setHighlightQuery(searchValue);

        if (searchValue === '') {
            setData([...data2]);
        } else {
            const filteredData = data2.filter(item =>
                item.title.toLowerCase().includes(searchValue.toLowerCase()) ||
                item.body.toLowerCase().includes(searchValue.toLowerCase())
            );
            setData(filteredData);
        }
    };

    return (
        <Grid container spacing={2} alignItems="center" sx={{ p: 2 }}>
            <Grid item xs={12} md={6}>
                <h4>{pageTitle}</h4>
            </Grid>

            {
                isRoleCheckList(authUser.userRoles, [1, 373, 370, 369, 372]) && (
                    <Grid item xs={12} md={2}>
                        <Button
                            variant="contained"

                            onClick={() => setAddDialogStatus(true)}
                            fullWidth
                        >
                            Şablon Ekle
                        </Button>
                    </Grid>
                )
            }

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    size="small"
                    placeholder="Şablon ara..."
                    value={searchText}
                    onChange={handleSearch}
                />
            </Grid>

            <AddUpdateAgendaTemplateDialog
                open={addDialogStatus}
                onClose={() => setAddDialogStatus(false)}
                afterUpdateFunc={afterUpdateFunc}
                addAfterTable={addAfterTable}
            />
        </Grid>
    );
};

export default AgendaTemplateDataTableToolbar 